module.exports = __webpack_public_path__ + "img/table-action.227b02b9.svg";